export default class BaseError extends Error {
  constructor(message) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BaseError);
    }

    this.name = 'Error';
    this.message = message;
  }
}
